const hasNotCommonConditionMessage =
	'Adicione uma condição de pagamento para não assinantes do Clube Muviflex '

const hasNotConditionForMembersMessage =
	'Adicione uma condição de pagamento para assinantes do Clube Muviflex'

const missingOnlyPointsConditionMessage =
	'Adicione uma condição de pagamento apenas com pontos para não assinantes do Clube Muviflex'

const missingOnlyPointsConditionForSubscribersMessage =
	'Adicione uma condição de pagamento apenas com pontos para assinantes do Clube Muviflex'

const notEnoughConditionsMessage =
	'Adicione mais uma condição de pagamento para não assinantes do Clube Muviflex'

export {
	notEnoughConditionsMessage,
	hasNotCommonConditionMessage,
	hasNotConditionForMembersMessage,
	missingOnlyPointsConditionMessage,
	missingOnlyPointsConditionForSubscribersMessage
}
